import { object, string } from "yup";

const validationSchema = object().shape({
  assetName: string().required("You must enter an Asset Name"),
  purpose: string().required("You must enter a Purpose"),
  fileTypes: string().required("You must enter at least one File Type"),
});

export default () => validationSchema;
